import './conversions-filter.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import InputField from '../../../shared/form-elements/input';

const Form = ({intl}) => (
	<form className="conversions-filter">
		<div className="conversions-filter__element">
			<Field
				name="conversionsFrom"
				placeholder={intl('Leads from')}
				showLabel={false}
				component={InputField} />
		</div>
	</form>
);

Form.propTypes = {
	intl: PropTypes.func
};

export default reduxForm({
	form: 'conversionsFromStatisticsForm'
})(Form);




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/form/conversions-filter.js